(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(`._header_m076r_1{z-index:3;background-color:#fff}._header_container_m076r_6{margin-bottom:2px}._neu-image_wrapper_m076r_10{max-width:100%;height:auto}._neu_image_wrapper_m076r_15{display:flex;align-items:center}@media (max-width: 576px){._neu_image_wrapper_m076r_15{justify-content:center;width:100%}}._neu_image_wrapper_m076r_15 .neu-image{margin:0 auto}
._top_navigation_container_br4ci_1{white-space:nowrap}._neu-dropdown_br4ci_5:hover{padding:var(--neu-spacer-2, 4px);border-radius:50%;color:var(--neu-blue-60)}._dropdown_items_br4ci_11{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._dropdown_items_active_br4ci_16{background-color:var(--link-pressed-background, #6a91af)}@media (max-width: 993px){._dropdown_container_br4ci_21{display:none}}@media (min-width: 993px){._mobile_menu_br4ci_27{display:none}}
._mhoTabsWrapper_1vsck_1{display:grid;grid-template-columns:1fr;gap:var(--neu-spacer-6, 24px);align-items:start;margin-top:var(--neu-spacer-3, .5rem)}@media (min-width: 768px){._mhoTabsWrapper_1vsck_1{gap:var(--neu-spacer-7, 32px);grid-template-columns:224px 1fr}}@media (min-width: 992px){._mhoTabsWrapper_1vsck_1{grid-template-columns:312px 1fr}}._mhoTabsWrapper_1vsck_1 ._noBackgroundTab_1vsck_19{background:none;box-shadow:none!important}._mhoTabsWrapper_1vsck_1 ._minH320_1vsck_23{min-height:320px}._mhoTabsWrapper_1vsck_1.neu-list{box-shadow:var(--neu-elevation-1) var(--neu-elevation-color)}
._certificationImageContainer_1gn0m_1{display:flex;justify-content:end;align-items:center;width:100%}@media (max-width: 660px){._certificationImageContainer_1gn0m_1{justify-content:center;width:100%;height:72px}}._certificationImageContainer_1gn0m_1>button>figure{margin:0}._imageContainer_1gn0m_19>figure{margin:0}._certificationButton_1gn0m_23{padding:var(--neu-spacer-0);background-color:transparent;min-width:auto;min-height:auto;border:none;text-align:center;cursor:pointer}._certificationButton_1gn0m_23:active,._certificationButton_1gn0m_23:focus,._certificationButton_1gn0m_23:hover{transform:scale(1.2);transition:transform .3s ease-in-out;background-color:transparent}._certificationButton_1gn0m_23:focus-visible{outline:revert;background-color:transparent}._modal_wrapper_3fxo4_1{max-height:600px}._modal_header_3fxo4_5{text-align:center}._modal_description_3fxo4_9{padding-top:20px;text-align:left;line-height:26px}._modal_description_3fxo4_9>p{line-height:26px}._modal_description_3fxo4_9>ul>li::marker{font-size:1.5em;font-weight:700}._modal_description_3fxo4_9>ul{padding-left:22px}._modal_image_3fxo4_28{width:200px}._footerSection_96jav_1{padding:70px 0 30px;background-color:#fff}@media (max-width: 768px){._footerSection_96jav_1{padding:30px var(--neu-spacing-0, 0px)}}._footerContainer_96jav_11{padding:var(--neu-spacing-0, 0) var(--neu-spacing-4, 12px);display:grid;grid-template-columns:1fr 1fr;grid-template-areas:"contact privacy" "links links"}@media (min-width: 1400px){._footerContainer_96jav_11{max-width:1320px}}@media (max-width: 660px){._footerContainer_96jav_11{align-items:center;grid-template-columns:1fr;grid-template-areas:"contact" "links" "privacy";place-items:center}}._contactArea_96jav_31{grid-area:contact}._logoImageContainer_96jav_35{display:flex;justify-content:start;padding-bottom:10px}@media (max-width: 660px){._logoImageContainer_96jav_35{justify-content:center;padding-bottom:var(--neu-spacing-6, 20px)}}._logoImageContainer_96jav_35>figure{margin:var(--neu-spacing-0, 0px)}._contactInfo_96jav_51{text-wrap:balance;text-align:center}@media (min-width: 768px){._contactInfo_96jav_51{text-align:start}}._linkArea_96jav_61{grid-area:links;display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;justify-content:center;padding-block:var(--neu-spacing-6, 20px);gap:var(--neu-spacing-6, 20px)}@media (min-width: 1024px){._linkArea_96jav_61{justify-content:start}}@media (max-width: 660px){._linkArea_96jav_61{flex-direction:column;align-items:center;gap:10px}}._privacyArea_96jav_84{grid-area:privacy;display:grid;grid-template-areas:"certification-image" "privacy-info"}@media (min-width: 1024px){._privacyArea_96jav_84{column-gap:20px;grid-template-columns:1fr max-content;grid-template-areas:"privacy-info certification-image"}}@media (max-width: 660px){._privacyArea_96jav_84{column-gap:20px;align-items:center}}._privacyInfoContainer_96jav_103{grid-area:privacy-info;display:flex;flex-direction:column;align-items:end;padding-top:var(--neu-spacing-1, 2px)}@media (max-width: 660px){._privacyInfoContainer_96jav_103{padding:var(--neu-spacing-6, 20px);align-items:center;text-align:center}}@media (min-width: 1024px){._privacyInfoContainer_96jav_103{justify-content:center}}._privacyInfo_96jav_103{text-wrap:balance;text-align:center}@media (min-width: 768px){._privacyInfo_96jav_103{text-align:end}}
._mho_alert_wrapper_1lqun_1 .neu-snackbar{--snackbar-radius: 0}
._table_usmlv_1 th{border-top:none;padding:var(--neu-spacing-4, .75rem) 0 var(--neu-spacing-3, .5rem)}._table_usmlv_1 th:not(:last-of-type){width:50%}@media (min-width: 360px){._table_usmlv_1 th:not(:last-of-type){width:60%}}@media (min-width: 576px){._table_usmlv_1 th:not(:last-of-type){width:70%}}@media (min-width: 992px){._table_usmlv_1 th:not(:last-of-type){width:37.5%}}@media (min-width: 1200px){._table_usmlv_1 th:not(:last-of-type){width:40%}}@media (max-width: 480px){._table_usmlv_1 th:not(:last-of-type) h3{white-space:normal!important}}._table_usmlv_1 td{padding:var(--neu-spacing-4, .75rem) 0;max-width:0}._table_usmlv_1 td p{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._table_usmlv_1 tr:last-of-type>td{border-bottom:none}._table_usmlv_1 tfoot{border-top:1px solid var(--table-border)}@media (max-width: 992px){._table_usmlv_1 th{padding:var(--neu-spacing-1, .125rem) 0}._table_usmlv_1 td{padding:var(--neu-spacing-3, .5rem) 0}}._table_usmlv_1 tbody tr:hover :is(th,td){background:var(--table-background)!important}._description_usmlv_64 p,._item_usmlv_65 p{margin:0}._description_usmlv_64>td,._item_usmlv_65>td{border-top:none}._item_usmlv_65>td:first-of-type{max-width:75px}@media (min-width: 576px){._item_usmlv_65>td:first-of-type{max-width:85px}}@media (min-width: 992px){._item_usmlv_65>td:first-of-type{max-width:110px}}._item_usmlv_65>td:last-of-type{width:auto;max-width:none}._description_usmlv_64>td{padding-top:0}._headerRowWithDescription_usmlv_99 th{padding:0;border-bottom:none}._headerRowWithDescription_usmlv_99+tr>td{padding:0;padding-bottom:var(--neu-spacing-3, .5rem);border-top:none}
._formInput_tgf87_1 button{text-align:left}._divider_23elx_1{width:100%;height:1px}
._card_items_1xzq2_1{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._card_items_1xzq2_1:hover,._card_items_1xzq2_1:focus{background-color:var(--neu-gray-10, #e2e2e2)}._card_items_1xzq2_1:active{background-color:var(--neu-blue-10, #d3e5f2)}@media (min-width: 768px){._card_items_1xzq2_1._header_link_1xzq2_12{display:none}}._link_icon_container_1xzq2_17{width:var(--neu-spacer-6, 1.5rem);text-align:center}._link_icon_container_1xzq2_17>figure{margin:0}._userEmail_std5a_1{text-overflow:ellipsis;max-width:284px}._profileCardContainer_std5a_6{padding-left:1.5rem}._profileCardContainer_std5a_6 .neu-dropdown--menu{max-width:284px!important;transform:translate3d(2px,23px,0)!important}@media (max-width: 660px){._profileCardContainer_std5a_6 .neu-dropdown--menu{inset:0px 0px auto auto;transform:translate3d(4px,23px,0)}}._profileCardContainer_std5a_6 .neu-dropdown--menu ul{max-height:none!important}._profileCardContainer_std5a_6 .neu-dropdown--menu li,._profileCardContainer_std5a_6 .neu-dropdown--menu a{width:284px!important}._profileCardContainer_std5a_6 .neu-dropdown--menu a:hover{color:var(--neu-gray-100)}._firstName_std5a_31{font-size:20px!important;text-overflow:ellipsis;max-width:284px}
._description_35t4d_1 p{margin:0}@media (min-width: 768px){._addLinkForm-input1_35t4d_6{width:33%}}@media (min-width: 768px){._addLinkForm-input2_35t4d_12{width:66%}}._disclaimerText_35t4d_17{line-height:1.125rem}
._formInput_ffgvo_1{display:flex;align-items:center;width:var(--custom-width, 100%)}._card_1b673_1{width:100%;aspect-ratio:3/1.8;border:3px dashed rgb(var(--neu-gray-10-light, 226, 226, 226));background-color:rgb(var(--neu-plain-0-light, 255, 255, 255));border-radius:var(--neu-border-radius-default, 8px);overflow:hidden}._card_1b673_1:has(input:focus){border-color:rgb(var(--neu-gray-20-light, 226, 226, 226))}@media (min-width: 769px){._card_1b673_1{max-height:220px}}._icon_1b673_18{font-size:2.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin-bottom:10px}._cardTitletext_1b673_24{font-size:1.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin:0;padding:5px 0}@media (max-width: 576px){._cardTitletext_1b673_24{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._description_1b673_39{font-size:var(--neu-font-size, 1rem);color:rgb(var(--neu-gray-10-dark, 31, 31, 31));margin:0}@media (max-width: 576px){._description_1b673_39{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._alertError_1b673_53{padding:var(--neu-spacer-4, .75rem);text-align:center;margin-top:var(--neu-spacer-5, 1rem);position:relative}._uploadedImageWrapper_1b673_60{width:100%;height:100%}._uploadedImage_1b673_60{width:100%;height:100%;position:relative;transform:translate(-50%,-50%);top:50%;left:50%}._uploadedImage_1b673_60 figure{width:100%;height:100%;margin:0}._uploadedImage_1b673_60 figure div{height:100%;width:100%}._uploadedImage_1b673_60 figure img{width:100%;height:100%;object-fit:contain}._reuploadMessage_1b673_88{position:absolute;bottom:0;left:0;color:#fff!important;background:#00000080;width:100%;text-align:center;padding:5px 0;display:none!important;z-index:10}._uploadedContainer_1b673_101{position:relative;width:100%;height:100%}._uploadedContainer_1b673_101:focus,._uploadedContainer_1b673_101:hover>div._reupload_message_1b673_106{display:block!important}._fileInput_1b673_110{height:1px;width:1px;opacity:0;position:absolute}
._formItem_r52t0_1{flex:1}
._linkField_kas8y_1{min-width:fit-content;padding-top:var(--neu-spacing-2, .25rem)}._text_field_1gmpc_1 p{margin:0}@media (max-width: 768px){._image_field_1gmpc_7{height:6.25rem;width:6.25rem}}._divider_h91qf_1{height:1px;transform:translateY(-21px)}
._modalContentContainer_10hs1_1{max-height:90vh;overflow:auto}@media (max-width: 475px){._modalContentContainer_10hs1_1{max-height:85vh}}
._description_1nfzp_1 p{margin:0}._searchItem_1nfzp_5{background-color:var(--neu-plain-0, #fff)}._noItemErrorMessage_1nfzp_9 ul li::marker{color:var(--neu-plain-100, #000)}
._horizontalTabsWrapper_lulv0_1{display:flex;width:100%}._horizontalTabsWrapper_lulv0_1 .unit-tab{flex:1 1 0;min-width:0;align-items:center;justify-content:center}._horizontalTabsWrapperSc_lulv0_12{padding-left:0;padding-right:0}._horizontalTabsCard_lulv0_17 .unit-content{padding:0}
._imageContainer_1xsj3_1{margin:16px 0;position:relative;min-height:104px;min-width:104px;height:fit-content;width:fit-content}._editButton_1xsj3_10{position:absolute;bottom:0;right:0;background-color:var(--neu-gray-10, "#e2e2e2")!important}._fileInput_1xsj3_17{width:1px;height:1px;display:none}._formItemPreferredFacilityState_1eisr_1{width:100%!important;min-width:50%!important;flex:1}@media screen and (min-width: 960px){._formItemPreferredFacilityState_1eisr_1{flex:.2;max-width:140px!important;min-width:140px!important}}._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{width:100%!important;padding-right:24px!important}@media screen and (max-width: 380px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:265px!important}}@media screen and (min-width: 381px) and (max-width: 575px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:305px!important}}@media screen and (min-width: 576px) and (max-width: 820px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:196px!important}}@media screen and (min-width: 821px) and (max-width: 1024px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:320px!important}}`)),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsx as e, jsxs as E, Fragment as V } from "react/jsx-runtime";
import { useState as L, useCallback as bn, useEffect as v, useMemo as qn } from "react";
import { useI18n as z } from "next-localization";
import { NeuModal as _, NeuFeedback as Pe, NeuSnackbar as qe, NeuButton as xe, NeuRadio as Me, NeuCard as Gn } from "@hcahealthcaredpx/neutron-react";
import { T as Ae, i as A, M as Be, P as jn } from "../../chunks/page-content.B0ugSU6N.js";
import { withDatasourceCheck as _n } from "@sitecore-jss/sitecore-jss-nextjs";
import { u as te } from "../../chunks/use-connected-relationship-info.DvMNYpDA.js";
import { S as Mn, q as ue } from "../../chunks/stale.constant.De1PuSBj.js";
import { useQuery as Ln, useMutation as we, useQueryClient as Ge } from "@tanstack/react-query";
import { f as $n, h as Un, c as je } from "../../chunks/use-account.DkVfV1FC.js";
import { u as ve } from "../../chunks/useModal.DSDGkQa1.js";
import { s as y, l as C, o as Fn, a as Sn, u as _e, b as Kn, Z as Zn, M as Qn } from "../../chunks/types.BJMlOVBS.js";
import { M as se, b as xn, c as Cn } from "../../chunks/modifiable-list.C-OdvAIi.js";
import { c as $e } from "../../chunks/clsx.OuTLNxxd.js";
import { useForm as Nn, useFormContext as Ue } from "react-hook-form";
import { u as An } from "../../chunks/useNetworkStatus.B65eRjoK.js";
import { R as N, f as Ce, F as Le, C as Yn } from "../../chunks/form-mask-input.92EW49hv.js";
import { u as wn, a as Ke } from "../../chunks/use-update-account.Cr_jUcK8.js";
import { F as w, b as pe, a as Y, D as Re } from "../../chunks/form-wrapper.CxSd-0ur.js";
import { M as Ze } from "../../chunks/mho-action-buttons.fY1B40h9.js";
import { s as Oe, f as Wn, i as Xn, p as Ne, u as Jn, m as Dn } from "../../chunks/utils.CWNG23OC.js";
import { r as eo } from "../../chunks/sessions-api.CDuxaXsQ.js";
import { u as no } from "../../chunks/use-accounts-relationships.L7d75NNZ.js";
import { a as Qe } from "../../chunks/api.DHdhNbok.js";
import { saveTimestampToLocalStorage as ke } from "../../utils/storage/index.js";
import { P as He, S as ae, F as oo } from "../../chunks/photo-card.AEcG6Xxx.js";
import { F as ro } from "../../chunks/form-date-picker.LFmaEfS6.js";
import { getFormattedDate as ao } from "../../utils/date-time/index.js";
import { u as so } from "../../chunks/use-accounts-relation-types.BZfXDW3J.js";
const to = () => Ln({
  queryKey: ue.employmentStatuses,
  queryFn: () => $n(),
  staleTime: Mn,
  select: (s) => s.data
}), lo = [
  { value: "CELL", label: "Cell" },
  { value: "HOME", label: "Home" },
  { value: "WORK", label: "Work" }
], Ee = {
  address1: "address1",
  address2: "address2",
  city: "city",
  state: "state",
  zip: "zip"
}, Ve = {
  maxSizeMB: 1,
  useWebWorker: !0
}, io = "_modalContentContainer_10hs1_1", Ye = {
  modalContentContainer: io
}, mo = (s, n) => {
  const o = s ? y().min(1, {
    message: n(
      "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
    )
  }).regex(N.address, {
    message: n(
      "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
    )
  }) : y().regex(N.address, {
    message: n(
      "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
    )
  }).or(C("")), l = s ? y().min(1, {
    message: n("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidCity")
  }).regex(N.city, {
    message: n("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidCity")
  }) : y().regex(N.city, {
    message: n("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidCity")
  }).or(C("")), a = s ? y().min(1, {
    message: n("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidZip")
  }).max(10, {
    message: n("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidZip")
  }).regex(N.zipCode, {
    message: n("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidZip")
  }) : y().max(10, { message: n("Please enter a valid zip") }).regex(N.zipCode, {
    message: n("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidZip")
  }).or(C("")), d = s ? y().min(1, {
    message: n("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidState")
  }) : y().or(C(""));
  return Fn({
    employmentStatus: y().min(1, {
      message: n(
        "Mho.Profile.InsuranceEmploymentInformation.Employment.ErrorMessageEmploymentStatus"
      )
    }).or(C("")),
    employerName: y().min(1, {
      message: n(
        "Mho.Profile.InsuranceEmploymentInformation.Employment.ErrorMessageEmployerName"
      )
    }).regex(N.name, {
      message: n(
        "Mho.Profile.InsuranceEmploymentInformation.Employment.ErrorMessageEmployerName"
      )
    }).or(C("")),
    employerPhone: y().max(13, {
      message: n(
        "Mho.Profile.InsuranceEmploymentInformation.Employment.ErrorMessagePhoneValidation"
      )
    }).regex(N.phone, {
      message: n(
        "Mho.Profile.InsuranceEmploymentInformation.Employment.ErrorMessagePhoneValidation"
      )
    }).or(C("")),
    employerFax: y().max(13, {
      message: n(
        "Mho.Profile.InsuranceEmploymentInformation.Employment.ErrorMessageFaxValidation"
      )
    }).regex(N.phone, {
      message: n(
        "Mho.Profile.InsuranceEmploymentInformation.Employment.ErrorMessageFaxValidation"
      )
    }).or(C("")),
    address1: o,
    address2: y().regex(N.address, {
      message: n(
        "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
      )
    }).or(C("")),
    city: l,
    state: d,
    zip: a
  });
}, co = (s) => s.map((o) => ({
  value: o.value,
  label: o.status
})), Io = (s, n) => {
  var o, l, a, d, i, m;
  return n ? [
    s,
    n.name,
    n.phone ? `${n.phone} - Work` : void 0,
    n.fax ? `${n.fax} - Fax` : void 0,
    `${(o = n.address) == null ? void 0 : o.addressLine1} ${(l = n.address) != null && l.addressLine2 ? `, ${(a = n.address) == null ? void 0 : a.addressLine2}` : ""}`,
    (d = n.address) != null && d.city && ((i = n.address) != null && i.state) && ((m = n.address) != null && m.zip) ? `${n.address.city}, ${n.address.state} ${n.address.zip}` : void 0
  ].filter(Boolean) : "";
}, uo = ({
  isOpen: s,
  onClose: n,
  data: o,
  statuses: l,
  employmentTitle: a,
  addressTitle: d,
  showSuccessSnackbar: i
}) => {
  var W, R, P, ie, me, D, ee, ne, be, he, oe, ye, ce, ge;
  const { t: m } = z(), { isOnline: g } = An(), { connectedRelUsername: t } = te(), [f, u] = L(!1), [c, r] = L(void 0), I = co(l), p = l == null ? void 0 : l.find((b) => {
    var x;
    return b.value === ((x = o.employment) == null ? void 0 : x.status);
  }), { data: F = [] } = wn({
    options: {
      isAbbreviationAsLabel: !0
    }
  }), { mutate: k, isPending: G } = Ke({
    onSuccess: () => {
      le(), i();
    },
    onError: (b) => {
      var x;
      r(((x = b == null ? void 0 : b.message) == null ? void 0 : x.toString()) || m("Mho.FormValidations.FailedToSave"));
    }
  }), q = {
    employmentStatus: (p == null ? void 0 : p.value) ?? "",
    employerName: ((W = o == null ? void 0 : o.employment) == null ? void 0 : W.name) ?? "",
    employerPhone: Ce.phone(((R = o == null ? void 0 : o.employment) == null ? void 0 : R.phone) ?? ""),
    employerFax: Ce.phone(((P = o == null ? void 0 : o.employment) == null ? void 0 : P.fax) ?? ""),
    address1: ((me = (ie = o == null ? void 0 : o.employment) == null ? void 0 : ie.address) == null ? void 0 : me.addressLine1) ?? "",
    address2: ((ee = (D = o == null ? void 0 : o.employment) == null ? void 0 : D.address) == null ? void 0 : ee.addressLine2) ?? "",
    city: ((be = (ne = o == null ? void 0 : o.employment) == null ? void 0 : ne.address) == null ? void 0 : be.city) ?? "",
    state: ((oe = (he = o == null ? void 0 : o.employment) == null ? void 0 : he.address) == null ? void 0 : oe.state) ?? "",
    zip: ((ce = (ye = o == null ? void 0 : o.employment) == null ? void 0 : ye.address) == null ? void 0 : ce.zip) ?? ""
  }, U = bn(
    () => mo(f, m),
    [f, m]
  ), h = Nn({
    defaultValues: q,
    mode: "all",
    resolver: Sn(U())
  }), {
    formState: { errors: X, isDirty: $ },
    watch: K,
    reset: j
  } = h, B = K();
  v(() => {
    o && j(q);
  }, [o]), v(() => {
    const b = Object.values(Ee).some((x) => typeof B[x] < "u" && B[x] !== "");
    u(b);
  }, [B]);
  const J = ((ge = B.employmentStatus) == null ? void 0 : ge.length) === 0 || !$, fe = (b) => {
    if (!g) return;
    const x = {
      status: (b == null ? void 0 : b.employmentStatus) || "",
      name: b == null ? void 0 : b.employerName,
      phone: b.employerPhone,
      fax: b.employerFax,
      address: {
        addressLine1: (b == null ? void 0 : b.address1) || "",
        addressLine2: (b == null ? void 0 : b.address2) || "",
        city: (b == null ? void 0 : b.city) || "",
        state: (b == null ? void 0 : b.state) || "",
        zip: (b == null ? void 0 : b.zip) || "",
        country: ""
      }
    };
    k({
      user: {
        myHealthOneId: o.user.myHealthOneId
      },
      employment: x,
      connectedRelUsername: t
    });
  }, le = () => {
    j(q), r(void 0), n();
  };
  return /* @__PURE__ */ e(
    _,
    {
      active: s,
      label: (a == null ? void 0 : a.value) || "",
      onNeuDismiss: le,
      size: "large",
      backdropDismiss: !1,
      children: /* @__PURE__ */ E("div", { className: $e("pt-1 pb-3", Ye.modalContentContainer), children: [
        /* @__PURE__ */ e(
          Ae,
          {
            kind: "error",
            showAlert: !A(c),
            className: "mb-4 mx-3",
            children: c
          }
        ),
        /* @__PURE__ */ E(
          w,
          {
            methods: h,
            onSubmit: fe,
            cancelButtonText: m(
              "Mho.Profile.InsuranceEmploymentInformation.ButtonLabels.CancelButtonLabel"
            ),
            onCancel: le,
            submitButtonText: m(
              "Mho.Profile.InsuranceEmploymentInformation.ButtonLabels.SaveButtonLabel"
            ),
            isSubmitDisabled: J,
            buttonsAlignment: "end",
            children: [
              /* @__PURE__ */ e(w.Row, { children: /* @__PURE__ */ e(
                pe,
                {
                  name: "employmentStatus",
                  label: m(
                    "Mho.Profile.InsuranceEmploymentInformation.Employment.EmploymentStatusLabel"
                  ),
                  items: I || [],
                  required: !0
                }
              ) }),
              /* @__PURE__ */ e(w.Row, { children: /* @__PURE__ */ e(
                Y,
                {
                  name: "employerName",
                  label: m("Mho.Profile.InsuranceEmploymentInformation.Employment.EmployerNameLabel"),
                  maxLength: 100
                }
              ) }),
              /* @__PURE__ */ E(w.Row, { className: "row-gap-3", children: [
                /* @__PURE__ */ e(
                  Le,
                  {
                    name: "employerPhone",
                    format: "phone",
                    label: m("Mho.Profile.InsuranceEmploymentInformation.Employment.EmployerPhoneLabel")
                  }
                ),
                /* @__PURE__ */ e(
                  Le,
                  {
                    name: "employerFax",
                    format: "phone",
                    label: m("Mho.Profile.InsuranceEmploymentInformation.Employment.EmployerFaxLabel")
                  }
                )
              ] }),
              /* @__PURE__ */ e(Be, { level: "2", className: "neu-display-6 fw-bold mt-4", marginBottom: "0", children: (d == null ? void 0 : d.value) || "" }),
              /* @__PURE__ */ e(Re, {}),
              /* @__PURE__ */ e(w.Row, { children: /* @__PURE__ */ e(
                Y,
                {
                  name: Ee.address1,
                  label: m(
                    "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.EmployerAddress1Label"
                  ),
                  required: f,
                  maxLength: 50
                }
              ) }),
              /* @__PURE__ */ e(w.Row, { children: /* @__PURE__ */ e(
                Y,
                {
                  name: Ee.address2,
                  label: m(
                    "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.EmployerAddress2Label"
                  ),
                  maxLength: 50
                }
              ) }),
              /* @__PURE__ */ E(w.Row, { className: "flex-sm-column row-gap-3 flex-md-row ", children: [
                /* @__PURE__ */ e(
                  Y,
                  {
                    name: Ee.city,
                    label: m("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.CityLabel"),
                    required: f,
                    maxLength: Yn
                  }
                ),
                /* @__PURE__ */ e(
                  pe,
                  {
                    "aria-live": "polite",
                    name: Ee.state,
                    label: m(
                      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.StateLabel"
                    ),
                    items: F,
                    error: !!X[Ee.state],
                    required: f
                  }
                ),
                /* @__PURE__ */ e(
                  Le,
                  {
                    format: "zip",
                    name: Ee.zip,
                    label: m("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ZipCodeLabel"),
                    required: f
                  }
                )
              ] }),
              /* @__PURE__ */ e(w.Loader, { isPending: G, kind: "spinner" })
            ]
          }
        )
      ] })
    },
    "addEmploymentModal"
  );
}, po = (s) => we({
  ...s,
  mutationFn: ({ connectedRelUsername: n }) => Un({ connectedRelUsername: n })
}), fo = ({ isOpen: s, onClose: n, showSuccessSnackbar: o }) => {
  const { t: l } = z(), { isOnline: a } = An(), d = Ge(), [i, m] = L(""), { connectedRelUsername: g } = te(), { mutate: t, isPending: f } = po({
    onMutate: () => {
      m("");
    },
    onSuccess: () => {
      d.invalidateQueries({ queryKey: ue.user("PHOTO", g) }), n(), o();
    },
    onError: (u) => {
      var c;
      m(((c = u == null ? void 0 : u.message) == null ? void 0 : c.toString()) || l("Mho.FormValidations.FailedToSave"));
    }
  });
  return /* @__PURE__ */ e(
    _,
    {
      label: l("Mho.Profile.InsuranceEmploymentInformation.RemoveEmploymentModal.Title"),
      active: s,
      onNeuDismiss: n,
      children: f ? /* @__PURE__ */ e(_.Content, { children: /* @__PURE__ */ e(Pe, { kind: "spinner", size: "small" }) }) : /* @__PURE__ */ E(V, { children: [
        /* @__PURE__ */ E(_.Content, { children: [
          /* @__PURE__ */ e(Ae, { kind: "error", showAlert: !A(i), className: "mb-4", children: i }),
          /* @__PURE__ */ e("p", { children: l("Mho.Profile.InsuranceEmploymentInformation.RemoveEmploymentModal.Text") })
        ] }),
        /* @__PURE__ */ e(_.Footer, { children: /* @__PURE__ */ e(
          Ze,
          {
            buttonsAlignment: "end",
            primaryText: l(
              "Mho.Profile.InsuranceEmploymentInformation.ButtonLabels.YesButtonLabel"
            ),
            onPrimaryClick: () => t({ connectedRelUsername: g }),
            isPrimaryDisabled: !a,
            secondaryText: l(
              "Mho.Profile.InsuranceEmploymentInformation.ButtonLabels.CancelButtonLabel"
            ),
            onSecondaryClick: n
          }
        ) })
      ] })
    }
  );
}, ho = ({ fields: s, setError: n }) => {
  var G;
  const { t: o } = z(), { openModal: l, isOpen: a, closeModal: d } = ve(), {
    openModal: i,
    isOpen: m,
    closeModal: g
  } = ve(), { snackbarProps: t, showSnackbar: f } = _e(), { queryParams: u } = te({ levelOfDetail: "PHOTO" }), { data: c, error: r } = je({
    queryParams: u
  }), { data: I } = to(), p = () => {
    f(
      o("Mho.PageContent.Profile.GeneralInformation.ProfileSuccessfullyChanged"),
      "success",
      10
    );
  };
  v(() => {
    r && n(r == null ? void 0 : r.message);
  }, [r]);
  const F = ((G = I == null ? void 0 : I.find((q) => {
    var U;
    return q.value === ((U = c == null ? void 0 : c.employment) == null ? void 0 : U.status);
  })) == null ? void 0 : G.status) ?? "", k = Io(F, c == null ? void 0 : c.employment);
  return c ? /* @__PURE__ */ E(V, { children: [
    /* @__PURE__ */ e(Be, { level: "3", className: "fw-bold mt-4 neu-display-5", marginBottom: "0", children: o(
      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.GeneralInsuranceInfo.EmploymentLabel"
    ) }),
    /* @__PURE__ */ e(se, { headerText1: "", children: c != null && c.employment ? /* @__PURE__ */ e(
      xn,
      {
        itemText1: k,
        onEditButtonClick: () => l(),
        onDeleteButtonClick: () => i()
      }
    ) : /* @__PURE__ */ e(
      Cn,
      {
        text: o(
          "Mho.Profile.InsuranceEmploymentInformation.ButtonLabels.AddEmploymentButtonLabel"
        ),
        onClick: () => l()
      }
    ) }),
    /* @__PURE__ */ e(
      uo,
      {
        isOpen: a,
        onClose: d,
        data: c,
        showSuccessSnackbar: p,
        addressTitle: s == null ? void 0 : s.addressesTitle,
        employmentTitle: s == null ? void 0 : s.employmentTitle,
        statuses: I ?? []
      }
    ),
    /* @__PURE__ */ e(
      fo,
      {
        isOpen: m,
        onClose: g,
        showSuccessSnackbar: p
      }
    ),
    /* @__PURE__ */ e(qe, { ...t })
  ] }) : null;
}, yo = async (s) => {
  ke();
  const o = await Qe.post("api/accounts/insurance/insurance", s);
  if (!o.ok)
    throw new Error(await o.json());
  return o.json();
}, go = async (s) => {
  ke();
  const n = "api/accounts/insurance/insurance", o = new URLSearchParams(s).toString(), l = await Qe.delete(`${n}?${o}`);
  if (!l.ok)
    throw new Error(await l.json());
  return l.json();
}, Eo = async (s) => {
  ke();
  const o = await Qe.put("api/accounts/insurance/insurance", s);
  if (!o.ok)
    throw new Error(await o.json());
  return o.json();
}, Po = (s) => we({
  ...s,
  mutationFn: yo
}), bo = (s) => we({
  ...s,
  mutationFn: Eo
}), Mo = async (s) => {
  ke();
  const o = await fetch("/api/ims-image/ims-image", {
    method: "POST",
    headers: {},
    body: s
  });
  if (!(o.ok || o.redirected))
    throw new Error(await o.json());
  return o.json();
}, Lo = async (s) => {
  if (ke(), !s || s === "")
    throw new Error("No image id provided");
  const n = `/api/ims-image/ims-image?imageId=${s}&_=${Date.now()}`, o = await fetch(n, {
    method: "GET",
    headers: {
      "Content-Type": "image/jpeg"
    }
  });
  if (!(o.ok || o.redirected))
    throw new Error(await o.json());
  return new Blob([await o.blob()]);
}, kn = (s) => we({
  ...s,
  mutationFn: Mo
}), ze = (s) => Ln({
  queryKey: ue.imsImage(s),
  queryFn: () => Lo(s),
  staleTime: Mn
}), Tn = ({
  frontImageId: s,
  backImageId: n,
  setInsuranceNewCard: o,
  frontLabel: l,
  backLabel: a,
  frontDescription: d,
  backDescription: i,
  setIsLoading: m
}) => {
  const { t: g } = z(), [t, f] = L(null), [u, c] = L(s), [r, I] = L(null), [p, F] = L(n), [k, G] = L(!1), [q, U] = L(!1), {
    data: h,
    isSuccess: X,
    isPending: $
  } = ze(u), {
    data: K,
    isSuccess: j,
    isPending: B
  } = ze(p), W = u && p && ($ || B) || (k || q);
  return v(() => {
    if (X && h) {
      const R = new File([h], "cardFront", {
        type: h == null ? void 0 : h.type
      });
      f(R);
    }
    if (j && K) {
      const R = new File([K], "cardBack", {
        type: K == null ? void 0 : K.type
      });
      I(R);
    }
  }, [X, j]), v(() => {
    t && r && o({
      front: { file: t, imageType: "insuranceFront", id: u },
      back: { file: r, imageType: "insuranceBack", id: p }
    });
  }, [t, r]), v(() => {
    m(W);
  }, [W]), /* @__PURE__ */ e(V, { children: /* @__PURE__ */ E("div", { className: "d-flex flex-column flex-sm-row gap-0 gap-sm-4", children: [
    /* @__PURE__ */ e(
      He,
      {
        image: t ?? null,
        setImage: (R) => {
          R && (Oe(
            R,
            Ve,
            f,
            G
          ), c(""));
        },
        cardTitle: l || g(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddFrontCardLabel"
        ),
        cardDescription: d || g(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddCardUploadLabel"
        ),
        maxFileSizeKB: 3584,
        supprortedFileTypes: [
          ae.jpeg,
          ae.jpg,
          ae.png
        ],
        fileSizeErrorText: g("Mho.Profile.InsuranceEmploymentInformation.PhotoId.ErrorImageSize"),
        fileTypeErrorText: g("Mho.PageContent.Profile.GeneralInformation.ImageRestrictionsLabel"),
        reUploadText: g("Mho.Profile.InsuranceEmploymentInformation.PhotoId.ReUploadImageLabel"),
        uploadedImageAltText: g(
          "Mho.Profile.InsuranceEmploymentInformation.PhotoId.UploadedPreviewLabel"
        )
      }
    ),
    /* @__PURE__ */ e(
      He,
      {
        image: r ?? null,
        setImage: (R) => {
          R && (Oe(
            R,
            Ve,
            I,
            U
          ), F(""));
        },
        cardTitle: a || g(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddBackCardLabel"
        ),
        cardDescription: i || g(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddCardUploadLabel"
        ),
        maxFileSizeKB: 3584,
        supprortedFileTypes: [
          ae.jpeg,
          ae.jpg,
          ae.png
        ],
        fileSizeErrorText: g("Mho.Profile.InsuranceEmploymentInformation.PhotoId.ErrorImageSize"),
        fileTypeErrorText: g("Mho.PageContent.Profile.GeneralInformation.ImageRestrictionsLabel"),
        reUploadText: g("Mho.Profile.InsuranceEmploymentInformation.PhotoId.ReUploadImageLabel"),
        uploadedImageAltText: g(
          "Mho.Profile.InsuranceEmploymentInformation.PhotoId.UploadedPreviewLabel"
        )
      }
    )
  ] }) });
}, Ie = {
  address1: "address1",
  address2: "address2",
  city: "city",
  state: "state",
  zip: "zip"
}, T = {
  primary: "primary",
  insurancePhone: "insurancePhone",
  insuranceId: "insuranceId",
  insuranceGroup: "insuranceGroup",
  insuranceName: "insuranceName",
  ...Ie,
  cardHolderFirstName: "cardHolderFirstName",
  cardHolderLastName: "cardHolderLastName",
  cardHolderPhone: "cardHolderPhone",
  cardHolderPhoneType: "cardHolderPhoneType",
  cardHolderRelationType: "cardHolderRelationType"
}, Fo = ({
  addressFieldRequired: s
}) => {
  const { t: n } = z(), {
    formState: { errors: o }
  } = Ue(), { data: l = [] } = wn({
    options: {
      isAbbreviationAsLabel: !0
    }
  });
  return /* @__PURE__ */ E(V, { children: [
    /* @__PURE__ */ e(w.Row, { children: /* @__PURE__ */ e(
      Y,
      {
        name: Ie.address1,
        label: n(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.ClaimsAddress1Label"
        ),
        maxLength: 50,
        required: s
      }
    ) }),
    /* @__PURE__ */ e(w.Row, { children: /* @__PURE__ */ e(
      Y,
      {
        name: Ie.address2,
        label: n(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.ClaimsAddress2Label"
        ),
        maxLength: 50
      }
    ) }),
    /* @__PURE__ */ E(w.Row, { className: "flex-sm-column row-gap-3 flex-md-row ", children: [
      /* @__PURE__ */ e(
        Y,
        {
          name: Ie.city,
          label: n(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.CityLabel"
          ),
          maxLength: 25,
          required: s
        }
      ),
      /* @__PURE__ */ e(
        pe,
        {
          name: Ie.state,
          label: n(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.StateLabel"
          ),
          items: l,
          error: !!o[Ie.state],
          required: s
        }
      ),
      /* @__PURE__ */ e(
        Le,
        {
          format: "zip",
          name: Ie.zip,
          label: n(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.ZipCodeLabel"
          ),
          required: s
        }
      )
    ] })
  ] });
}, So = ({ relationshipItems: s, relationships: n }) => {
  var d;
  const { t: o } = z(), { getValues: l } = Ue(), a = (d = n == null ? void 0 : n.filter((i) => (i == null ? void 0 : i.relationType) !== "SELF")) == null ? void 0 : d.map((i) => {
    var m;
    return {
      value: i != null && i.id ? (m = i == null ? void 0 : i.id) == null ? void 0 : m.toString() : "",
      label: i ? `${i == null ? void 0 : i.firstName} ${i == null ? void 0 : i.lastName}` : ""
    };
  });
  return /* @__PURE__ */ E(V, { children: [
    /* @__PURE__ */ e("h3", { className: "neu-display-6 fw-bold mt-3", children: o(
      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.SelectRelationshipLabel"
    ) }),
    n != null && n.length ? /* @__PURE__ */ E(w.Row, { children: [
      /* @__PURE__ */ e(
        pe,
        {
          name: "relationshipId",
          label: o("Mho.PageContent.Profile.EmergencyContact.Labels.ContactName"),
          nullItemLabel: o("Mho.PageContent.Profile.EmergencyContact.Labels.SelectContact"),
          items: a || [],
          value: l("relationship"),
          required: !0
        }
      ),
      /* @__PURE__ */ e(
        pe,
        {
          name: "relationship",
          label: o(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.RelationshipFieldLabel"
          ),
          nullItemLabel: o(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.SelectRelationshipDropdownLabel"
          ),
          items: s || [],
          value: l("relationship"),
          required: !0
        }
      )
    ] }) : null,
    /* @__PURE__ */ e("p", { children: o("Mho.PageContent.Profile.EmergencyContact.Label.AddRelationshipNote") })
  ] });
}, xo = (s, n, o, l, a) => {
  const d = s ? y().min(1, {
    message: a(
      "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
    )
  }).max(50, {
    message: a(
      "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
    )
  }).regex(N.address, {
    message: a(
      "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
    )
  }) : y().regex(N.address, {
    message: a(
      "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
    )
  }).max(50, {
    message: "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
  }).or(C("")), i = s ? y().min(1, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidCity")
  }).max(25, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidCity")
  }).regex(N.city, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidCity")
  }) : y().regex(N.city, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidCity")
  }).max(25, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidCity")
  }).or(C("")), m = s ? y().min(1, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidZip")
  }).max(10, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidZip")
  }).regex(N.zipCode, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidZip")
  }) : y().max(10, { message: a("Please enter a valid zip") }).regex(N.zipCode, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidZip")
  }).or(C("")), g = s ? y().min(1, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidState")
  }) : y().or(C("")), t = n ? y().min(1, {
    message: a("Mho.Profile.ProfileGeneralInformation.PersonalSection.FirstNameErrorMessage")
  }).regex(N.name, {
    message: a("Mho.Profile.ProfileGeneralInformation.PersonalSection.FirstNameErrorMessage")
  }) : y().regex(N.name, {
    message: a("Mho.Profile.ProfileGeneralInformation.PersonalSection.FirstNameErrorMessage")
  }).or(C("")), f = n ? y().min(1, {
    message: a("Mho.Profile.ProfileGeneralInformation.PersonalSection.LastNameErrorMessage")
  }).regex(N.name, {
    message: a("Mho.Profile.ProfileGeneralInformation.PersonalSection.LastNameErrorMessage")
  }) : y().regex(N.name, {
    message: a("Mho.Profile.ProfileGeneralInformation.PersonalSection.LastNameErrorMessage")
  }).or(C("")), u = n ? y().min(1, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorPhoneNumber")
  }).max(13, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorPhoneNumber")
  }).regex(N.phone, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorPhoneNumber")
  }).or(C("")) : y().max(13, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorPhoneNumber")
  }).regex(N.phone, {
    message: a("Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorPhoneNumber")
  }).or(C("")), c = n ? y().min(1, {
    message: a("Mho.PageContent.Profile.EmergencyContact.Validation.ValidPhoneType")
  }).or(C("")) : y().or(C("")), r = n ? y().min(1, {
    message: a("Mho.PageContent.RecordsLinking.Form.Validations.ValidDate")
  }).or(C("")) : y().or(C("")), I = n ? y().min(1, {
    message: a("Mho.PageContent.Profile.EmergencyContact.Validation.ValidRelationshipPatient")
  }) : y().or(C("")), p = o ? y().min(1, {
    message: a("Mho.PageContent.Profile.EmergencyContact.Validation.ValidRelationshipPatient")
  }) : y().or(C(""));
  return Fn({
    insuranceName: y().min(1, {
      message: a("Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorInsuranceName")
    }).regex(N.name, {
      message: a("Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorInsuranceName")
    }),
    insurancePhone: y().max(13, {
      message: a("Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorPhoneNumber")
    }).regex(N.phone, {
      message: a("Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorPhoneNumber")
    }).or(C("")),
    insuranceGroup: y().regex(N.insuranceGroup, {
      message: a(
        "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorInsuranceGroup"
      )
    }).max(100, {
      message: a(
        "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorInsuranceGroup"
      )
    }).or(C("")),
    insuranceId: y().regex(N.insuranceId, {
      message: a(
        "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorInsuranceNumber"
      )
    }).max(100, {
      message: a(
        "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.ErrorInsuranceNumber"
      )
    }).or(C("")),
    address1: d,
    address2: y().max(50, {
      message: a(
        "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
      )
    }).regex(N.address, {
      message: a(
        "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
      )
    }).max(50, {
      message: a(
        "Mho.Profile.InsuranceEmploymentInformation.EmploymentAddress.ErrorValidAddress"
      )
    }).or(C("")),
    city: i,
    state: g,
    zip: m,
    relationship: p,
    relationshipId: y(),
    cardHolderRelationType: I,
    cardHolderFirstName: t,
    cardHolderLastName: f,
    cardHolderPhone: u,
    cardHolderPhoneType: c,
    cardHolderDateOfBirth: r,
    isCardholder: y(),
    primary: Kn()
  }).superRefine((F, k) => {
    const { isCardholder: G, relationshipId: q } = F;
    l && G === "false" && A(q) && k.addIssue({
      code: Zn.custom,
      message: a("Mho.PageContent.Profile.EmergencyContact.Labels.ValidContactName"),
      path: ["relationshipId"]
    });
  });
};
function Co() {
  const s = /* @__PURE__ */ new Date(), n = new Date(s.getFullYear() - 13, s.getMonth(), s.getDate());
  return { min: "1900-01-01", max: ao(n.toISOString(), "yyyy-MM-dd") ?? "" };
}
const No = ({
  relationshipItems: s,
  relationships: n = [],
  showForm: o,
  setShowForm: l
}) => {
  var f, u;
  const { t: a } = z(), { setValue: d, getValues: i } = Ue(), { min: m, max: g } = Co(), t = ((f = n == null ? void 0 : n.filter((c) => (c == null ? void 0 : c.relationType) !== "SELF")) == null ? void 0 : f.map((c) => {
    var I;
    const r = Wn(c == null ? void 0 : c.relationType);
    return {
      value: c != null && c.id ? (I = c == null ? void 0 : c.id) == null ? void 0 : I.toString() : "",
      label: c ? `${c == null ? void 0 : c.firstName} ${c == null ? void 0 : c.lastName} ${r ? `- ${r}` : ""}` : ""
    };
  })) || [];
  return o ? /* @__PURE__ */ E(V, { children: [
    /* @__PURE__ */ e("h2", { className: "neu-display-6 fw-bold mt-3", children: a(
      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.CardholderForm.CreateRelationshipLabel"
    ) }),
    /* @__PURE__ */ E(w.Row, { children: [
      /* @__PURE__ */ e(
        Y,
        {
          label: a(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.CardholderForm.FirstNameLabel"
          ),
          name: T.cardHolderFirstName,
          required: !0
        }
      ),
      /* @__PURE__ */ e(
        Y,
        {
          label: a(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.CardholderForm.LastNameLabel"
          ),
          name: T.cardHolderLastName,
          required: !0
        }
      )
    ] }),
    /* @__PURE__ */ e(w.Row, { children: /* @__PURE__ */ e(
      pe,
      {
        name: T.cardHolderRelationType,
        label: a(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.CardholderForm.RelationshipPatientLabel"
        ),
        nullItemLabel: a(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.SelectRelationshipDropdownLabel"
        ),
        items: s || [],
        required: !0
      }
    ) }),
    /* @__PURE__ */ e(w.Row, { children: /* @__PURE__ */ e(
      ro,
      {
        className: "w-100",
        name: "cardHolderDateOfBirth",
        label: a(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.CardholderForm.DateOfBirthLabel"
        ),
        required: !1,
        min: m,
        max: g
      }
    ) }),
    /* @__PURE__ */ E(w.Row, { children: [
      /* @__PURE__ */ e(
        Le,
        {
          label: a(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.CardholderForm.PrimaryPhoneLabel"
          ),
          format: "phone",
          name: T.cardHolderPhone,
          required: !0
        }
      ),
      /* @__PURE__ */ e(
        pe,
        {
          disabled: ((u = i(T.cardHolderPhone)) == null ? void 0 : u.length) === 0,
          name: T.cardHolderPhoneType,
          label: a(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.CardholderForm.PrimaryPhoneTypeLabel"
          ),
          items: lo,
          required: !0
        }
      )
    ] })
  ] }) : /* @__PURE__ */ E(V, { children: [
    /* @__PURE__ */ e("h3", { className: "neu-display-6 fw-bold mt-3", children: a(
      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.SelectRelationshipLabel"
    ) }),
    t.length > 0 && /* @__PURE__ */ e(w.Row, { children: /* @__PURE__ */ e(
      pe,
      {
        name: "relationship",
        label: a(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.RelationshipFieldLabel"
        ),
        nullItemLabel: a(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.SelectRelationshipDropdownLabel"
        ),
        items: t,
        required: !0
      }
    ) }),
    n.length < Qn && /* @__PURE__ */ e(se, { headerText1: "", children: /* @__PURE__ */ e(
      se.AddButton,
      {
        text: a(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddNewRelationshipLabel"
        ),
        onClick: () => {
          l(!0), d("relationship", "");
        }
      }
    ) })
  ] });
}, Ao = ({ t: s }) => /* @__PURE__ */ E(V, { children: [
  /* @__PURE__ */ e(w.Row, { children: /* @__PURE__ */ e(
    Y,
    {
      name: T.insuranceName,
      label: s(
        "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.NameLabel"
      ),
      required: !0
    }
  ) }),
  /* @__PURE__ */ E(w.Row, { className: "flex-sm-column row-gap-1 flex-md-row", children: [
    /* @__PURE__ */ e(
      Y,
      {
        name: T.insuranceId,
        label: s(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.IdOptionalLabel"
        ),
        maxLength: 50
      }
    ),
    /* @__PURE__ */ e(
      Y,
      {
        name: "insuranceGroup",
        label: s(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.GroupOptionalLabel"
        ),
        maxLength: 100
      }
    )
  ] }),
  /* @__PURE__ */ e(w.Row, { children: /* @__PURE__ */ e(
    Le,
    {
      name: T.insurancePhone,
      label: s(
        "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.PhoneOptionalLabel"
      ),
      format: "phone"
    }
  ) })
] }), wo = ({ onAddManuallyInfo: s, onClose: n, onContinue: o, continueDisabled: l }) => {
  const { t: a } = z();
  return /* @__PURE__ */ E("div", { className: "d-flex gap-3 flex-column justify-content-between align-items-end align-items-md-center flex-md-row", children: [
    /* @__PURE__ */ e(
      xe,
      {
        kind: "tertiary",
        type: "button",
        onClick: () => {
          s();
        },
        children: a(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.EnterInfoButtonLabel"
        )
      }
    ),
    /* @__PURE__ */ E("div", { className: "d-flex align-items-center flex-row justify-content-end mb-0 gap-3", children: [
      /* @__PURE__ */ e(
        xe,
        {
          kind: "secondary",
          type: "button",
          onClick: () => {
            n();
          },
          children: a(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.CancelButtonLabel"
          )
        }
      ),
      /* @__PURE__ */ e(xe, { disabled: l, onClick: () => o(), children: a(
        "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.ContinueButtonLabel"
      ) })
    ] })
  ] });
}, ko = ({
  isActive: s,
  insuranceId: n,
  data: o,
  fields: l,
  frontImage: a,
  backImage: d,
  onClose: i,
  showSuccessSnackbar: m,
  setInsuranceImages: g
}) => {
  var Je, De, en, nn, on, rn, an, sn, tn, ln, mn, cn, dn, In, un, pn, fn, hn, yn, gn, En;
  const { t } = z(), f = Ge(), { isConnectedRelationship: u, connectedRelUsername: c } = te(), r = n.length > 0 ? (Je = o == null ? void 0 : o.insuranceInfo) == null ? void 0 : Je.find((S) => {
    var H;
    return ((H = S == null ? void 0 : S.id) == null ? void 0 : H.toString()) === n;
  }) : null, I = qn(() => {
    if (!u || typeof window > "u") return null;
    const S = window.localStorage.getItem("mainUser");
    try {
      return JSON.parse(S || "{}");
    } catch {
      return null;
    }
  }, [u]), p = (De = I == null ? void 0 : I.contacts) == null ? void 0 : De.find((S) => Xn(S.contactType)), [F, k] = L(!!r), [G, q] = L(!1), [U, h] = L(!1), [X, $] = L(!1), [K, j] = L(""), [B, J] = L(!1), [fe, le] = L(!1), { data: W } = so(), { data: R } = no(), [P, ie] = L(null);
  let me = r && !A(r == null ? void 0 : r.cardFrontImageId) ? r.cardFrontImageId : "", D = r && !A(r == null ? void 0 : r.cardBackImageId) ? r.cardBackImageId : "";
  const ee = !!(!F || P || r != null && r.cardFrontImageId), ne = t(
    "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.VerifyInformationText"
  ), be = (en = l == null ? void 0 : l.addNewInsuranceDescription) == null ? void 0 : en.value, he = t(
    "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.Note"
  );
  let oe = "";
  ee ? oe = F ? ne : be : oe = F ? he : "";
  const ye = ((nn = r == null ? void 0 : r.guarantorUserRelationship) == null ? void 0 : nn.relationType) === "SELF" ? "" : ((rn = (on = r == null ? void 0 : r.guarantorUserRelationship) == null ? void 0 : on.id) == null ? void 0 : rn.toString()) ?? "", ce = {
    [T.primary]: r ? r.primary : A(o == null ? void 0 : o.insuranceInfo),
    frontImage: me ?? "",
    backImage: D ?? "",
    [T.insuranceName]: (r == null ? void 0 : r.insuranceName) ?? "",
    [T.insuranceId]: (r == null ? void 0 : r.insuranceNumber) ?? "",
    [T.insuranceGroup]: (r == null ? void 0 : r.insuranceGroup) ?? "",
    [T.insurancePhone]: Ce.phone(
      (r == null ? void 0 : r.insurancePhoneNumber) ?? ""
    ),
    [T.address1]: ((an = r == null ? void 0 : r.insuranceAddress) == null ? void 0 : an.addressLine1) ?? "",
    [T.address2]: ((sn = r == null ? void 0 : r.insuranceAddress) == null ? void 0 : sn.addressLine2) ?? "",
    [T.city]: ((tn = r == null ? void 0 : r.insuranceAddress) == null ? void 0 : tn.city) ?? "",
    [T.state]: ((ln = r == null ? void 0 : r.insuranceAddress) == null ? void 0 : ln.state) ?? "",
    [T.zip]: Ce.zip(((mn = r == null ? void 0 : r.insuranceAddress) == null ? void 0 : mn.zip) ?? ""),
    relationship: ye,
    relationshipId: "",
    isCardholder: ((cn = r == null ? void 0 : r.cardHolder) == null ? void 0 : cn.toString()) ?? "true",
    cardHolderFirstName: u ? (dn = I == null ? void 0 : I.user) == null ? void 0 : dn.firstName : "",
    cardHolderLastName: u ? (In = I == null ? void 0 : I.user) == null ? void 0 : In.lastName : "",
    cardHolderPhone: u ? Ce.phone((p == null ? void 0 : p.contactInfo) ?? "") : "",
    cardHolderPhoneType: u ? (p == null ? void 0 : p.contactType) ?? "" : "",
    cardHolderRelationType: u ? "SELF" : "",
    cardHolderDateOfBirth: u ? ((un = I == null ? void 0 : I.user) == null ? void 0 : un.dob) ?? "" : ""
  }, ge = bn(
    () => {
      var S;
      return xo(
        G,
        U,
        X,
        (S = l.isConnectedRelationship) == null ? void 0 : S.value,
        t
      );
    },
    [
      G,
      U,
      X,
      (pn = l.isConnectedRelationship) == null ? void 0 : pn.value,
      t
    ]
  ), b = Nn({
    defaultValues: ce,
    mode: "all",
    resolver: Sn(ge())
  }), {
    setValue: x,
    watch: M,
    reset: re,
    formState: { errors: Fe }
  } = b, O = M(), [vn, Se] = L("initial"), Bn = () => {
    ie(null), k(!1), J(!1), me = "", D = "", re();
  }, Te = () => {
    i(), Bn(), setTimeout(() => {
      Se("initial");
    }, 0), j("");
  }, { mutate: Rn, isPending: On } = Po({
    onMutate: () => {
      j("");
    },
    onSuccess: async () => {
      var S;
      !u && ((S = o == null ? void 0 : o.user) != null && S.myHealthOneId) && await eo(o.user.myHealthOneId), f.invalidateQueries({ queryKey: ue.userAll }), f.invalidateQueries({ queryKey: ue.userRelationships }), Te(), m();
    },
    onError: (S) => {
      j(S.message || t("Mho.FormValidations.FailedToSave"));
    }
  }), { mutate: Hn, isPending: Vn } = bo({
    onMutate: () => {
      j("");
    },
    onSuccess: () => {
      f.invalidateQueries({ queryKey: ue.userAll }), f.invalidateQueries({ queryKey: ue.userRelationships }), Te(), m();
    },
    onError: (S) => {
      var H;
      j(((H = S.message) == null ? void 0 : H.toString()) || t("Mho.FormValidations.FailedToSave"));
    }
  }), { mutate: We, isPending: Xe } = kn({
    onSuccess: (S) => {
      S.status.code === 200 && (S.data.imageType === "insuranceFront" && (x("frontImage", S.data.imageId), g({
        front: { id: S.data.imageId, imageType: "insuranceFront" }
      })), S.data.imageType === "insuranceBack" && (x("backImage", S.data.imageId), g({
        back: { id: S.data.imageId, imageType: "insuranceBack" }
      })));
    }
  });
  v(() => {
    o && re(ce), r && (k(!0), Se("updateInsurance"));
  }, [o, r, Se, I]), v(() => {
    const S = Object.values(Ie).some((H) => typeof O[H] < "u" && O[H] !== "");
    q(S);
  }, [O]), v(() => {
    h(
      O.isCardholder === "false" && B
    ), $(
      O.isCardholder === "false" && !B
    );
  }, [O.isCardholder, B]), v(() => {
    var S, H;
    if (P != null && P.front && ((S = P == null ? void 0 : P.front) == null ? void 0 : S.id) !== (r == null ? void 0 : r.cardFrontImageId)) {
      const de = P != null && P.front ? Ne(P == null ? void 0 : P.front) : null;
      de && We(de);
    }
    if (P != null && P.back && ((H = P == null ? void 0 : P.back) == null ? void 0 : H.id) !== (r == null ? void 0 : r.cardBackImageId)) {
      const de = P != null && P.back ? Ne(P == null ? void 0 : P.back) : null;
      de && We(de);
    }
  }, [P]);
  const zn = () => {
    const H = Jn(
      O,
      (r == null ? void 0 : r.id) ?? null,
      o,
      W,
      u ? I == null ? void 0 : I.dependentRelationships : R,
      o == null ? void 0 : o.user.myHealthOneId,
      u
    );
    (!Fe || Object.keys(Fe).length === 0) && (r ? Hn({ ...H, connectedRelUsername: c }) : Rn({ ...H, connectedRelUsername: c }));
  };
  return v(() => {
    r != null && r.cardFrontImageId && (r != null && r.cardBackImageId) && ie({
      front: { id: r == null ? void 0 : r.cardFrontImageId, imageType: "insuranceFront" },
      back: { id: r == null ? void 0 : r.cardBackImageId, imageType: "insuranceBack" }
    });
  }, [r]), /* @__PURE__ */ e(
    _,
    {
      label: t(
        r ? "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.GeneralInsuranceInfo.UpdateLabel" : "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddNewInsuranceLabel"
      ),
      active: s,
      onNeuDismiss: () => {
        Te();
      },
      size: "large",
      backdropDismiss: !1,
      children: /* @__PURE__ */ e("div", { className: $e("pt-1 pb-3 outline-none", Ye.modalContentContainer), children: On || Vn ? /* @__PURE__ */ e(Pe, { className: "pb-6", kind: "spinner" }) : /* @__PURE__ */ E(V, { children: [
        /* @__PURE__ */ e(
          Ae,
          {
            kind: "error",
            showAlert: !!K,
            className: "mb-4 mx-3",
            children: K
          }
        ),
        /* @__PURE__ */ E(
          w,
          {
            methods: b,
            showButtons: F,
            onSubmit: zn,
            onCancel: () => {
              Te();
            },
            submitButtonText: t(
              "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.SaveButtonLabel"
            ),
            cancelButtonText: t(
              "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.CancelButtonLabel"
            ),
            buttonsAlignment: "end",
            children: [
              /* @__PURE__ */ E("div", { className: "d-flex flex-column gap-md-4 flex-md-row justify-content-between align-items-start", children: [
                /* @__PURE__ */ e("p", { className: "flex-grow-1 mb-md-0 flex-shrink-md-0", children: oe }),
                F && /* @__PURE__ */ e("div", { className: "my-2 my-md-0 w-auto text-nowrap", children: /* @__PURE__ */ e(
                  oo,
                  {
                    name: T.primary,
                    label: l.setPrimaryInsuranceLabel.value,
                    disabled: A(n) && A(o == null ? void 0 : o.insuranceInfo) || (o == null ? void 0 : o.insuranceInfo) && o.insuranceInfo.length < 2 && !A(n)
                  }
                ) })
              ] }),
              ee && /* @__PURE__ */ E(V, { children: [
                /* @__PURE__ */ e(
                  Tn,
                  {
                    frontImageId: me || (a == null ? void 0 : a.id) || "",
                    backImageId: D || (d == null ? void 0 : d.id) || "",
                    setInsuranceNewCard: ie,
                    frontLabel: t(
                      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddFrontCardLabel"
                    ),
                    frontDescription: t(
                      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddCardUploadLabel"
                    ),
                    backLabel: t(
                      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddBackCardLabel"
                    ),
                    backDescription: t(
                      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddCardUploadLabel"
                    ),
                    setIsLoading: le
                  }
                ),
                (Xe || fe) && /* @__PURE__ */ e(Pe, { kind: "spinner", className: "px-6 py-4" })
              ] }),
              F ? /* @__PURE__ */ E(V, { children: [
                /* @__PURE__ */ e(Ao, { t }),
                /* @__PURE__ */ e("h2", { className: "neu-display-6 fw-bold mt-5", children: t(
                  "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddressOptionalLabel"
                ) }),
                /* @__PURE__ */ e(Re, {}),
                /* @__PURE__ */ e(Fo, { addressFieldRequired: G }),
                /* @__PURE__ */ e("h2", { className: "neu-display-6 fw-bold", children: t(
                  "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.CardholderLabel"
                ) }),
                /* @__PURE__ */ e(Re, {}),
                /* @__PURE__ */ E(
                  Me,
                  {
                    "aria-live": "off",
                    name: "isCardholder",
                    label: (fn = l.isConnectedRelationship) != null && fn.value ? t(
                      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.CardholderTextName"
                    ).replace(
                      "{name}",
                      `${((hn = o == null ? void 0 : o.user) == null ? void 0 : hn.firstName) || ""} ${((yn = o == null ? void 0 : o.user) == null ? void 0 : yn.lastName) || ""}`
                    ) : t(
                      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.CardholderText"
                    ),
                    value: O.isCardholder,
                    onNeuChange: (S) => {
                      var H, de, Pn;
                      x("isCardholder", S.value), u && O.isCardholder === "true" && (J(!1), x("cardHolderFirstName", (H = I == null ? void 0 : I.user) == null ? void 0 : H.firstName), x("cardHolderLastName", (de = I == null ? void 0 : I.user) == null ? void 0 : de.lastName), x("cardHolderPhone", p == null ? void 0 : p.contactInfo), x("cardHolderPhoneType", p == null ? void 0 : p.contactType), x("cardHolderRelationType", "SELF"), x("cardHolderDateOfBirth", (Pn = I == null ? void 0 : I.user) == null ? void 0 : Pn.dob)), !u && O.isCardholder === "true" && (J(!1), x("cardHolderFirstName", ""), x("cardHolderLastName", ""), x("cardHolderPhone", ""), x("cardHolderPhoneType", ""), x("cardHolderRelationType", ""), x("cardHolderDateOfBirth", ""));
                    },
                    required: !0,
                    children: [
                      /* @__PURE__ */ e(
                        Me.Item,
                        {
                          label: t(
                            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.YesRadioButtonLabel"
                          ),
                          value: "true"
                        }
                      ),
                      /* @__PURE__ */ e(
                        Me.Item,
                        {
                          label: t(
                            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.NoRadioButtonLabel"
                          ),
                          value: "false"
                        }
                      )
                    ]
                  }
                ),
                O.isCardholder === "false" && ((gn = l.isConnectedRelationship) == null ? void 0 : gn.value) && /* @__PURE__ */ e(
                  So,
                  {
                    setShowForm: J,
                    showForm: B,
                    relationshipItems: W,
                    relationships: (I == null ? void 0 : I.dependentRelationships) || []
                  }
                ),
                O.isCardholder === "false" && !((En = l.isConnectedRelationship) != null && En.value) && /* @__PURE__ */ e(
                  No,
                  {
                    setShowForm: J,
                    showForm: B,
                    relationshipItems: W,
                    relationships: R
                  }
                )
              ] }) : /* @__PURE__ */ e(
                wo,
                {
                  onClose: i,
                  onAddManuallyInfo: () => {
                    Se("addNewInsurance"), k(!0);
                  },
                  onContinue: () => {
                    Se("continue"), k(!0);
                  },
                  continueDisabled: Xe || !(P != null && P.front) || !(P != null && P.back)
                }
              )
            ]
          }
        )
      ] }) })
    },
    vn
  );
}, To = (s) => we({
  ...s,
  mutationFn: go
}), vo = ({ isOpen: s, onClose: n, showSuccessSnackbar: o, insuranceId: l }) => {
  const { t: a } = z(), d = Ge(), [i, m] = L(""), { connectedRelUsername: g } = te(), t = () => {
    n(), m("");
  }, { mutate: f, isPending: u } = To({
    onMutate: () => {
      m("");
    },
    onSuccess: () => {
      d.invalidateQueries({ queryKey: ue.user("FULL") }), t(), o();
    },
    onError: (r) => {
      var I;
      m(((I = r == null ? void 0 : r.message) == null ? void 0 : I.toString()) || a("Mho.FormValidations.FailedToSave"));
    }
  }), c = () => {
    m(""), f({ insuranceId: l, connectedRelUsername: g });
  };
  return /* @__PURE__ */ e(
    _,
    {
      label: a(
        "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.GeneralInsuranceInfo.RemoveLabel"
      ),
      active: s,
      onNeuDismiss: t,
      children: u ? /* @__PURE__ */ e(_.Content, { children: /* @__PURE__ */ e(Pe, { kind: "spinner", size: "small" }) }) : /* @__PURE__ */ E(V, { children: [
        /* @__PURE__ */ E(_.Content, { children: [
          /* @__PURE__ */ e(Ae, { kind: "error", showAlert: !A(i), className: "mb-4", children: i }),
          /* @__PURE__ */ e("p", { children: a(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.GeneralInsuranceInfo.RemoveText"
          ) })
        ] }),
        /* @__PURE__ */ e(_.Footer, { children: /* @__PURE__ */ e(
          Ze,
          {
            buttonsAlignment: "end",
            primaryText: a(
              "Mho.Profile.InsuranceEmploymentInformation.ButtonLabels.YesButtonLabel"
            ),
            onPrimaryClick: c,
            secondaryText: a(
              "Mho.Profile.InsuranceEmploymentInformation.ButtonLabels.CancelButtonLabel"
            ),
            onSecondaryClick: t
          }
        ) })
      ] })
    }
  );
}, Bo = ({ insuranceItems: s, onEdit: n, onDelete: o }) => {
  const { t: l } = z();
  return /* @__PURE__ */ E("div", { children: [
    /* @__PURE__ */ e(Be, { level: "3", className: "fw-bold mt-4 neu-display-5", marginBottom: "0", children: l(
      "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.GeneralInsuranceInfo.InsuranceLabel"
    ) }),
    s == null ? void 0 : s.map((a) => {
      const d = Dn(a), i = d.content, m = d.cardHolder;
      return /* @__PURE__ */ e(
        se,
        {
          headerText1: a.primary ? l(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.InsuranceAdditionalInfo.PrimaryInsuranceLabel"
          ) : l(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.InsuranceAdditionalInfo.AdditionalInsuranceLabel"
          ),
          headerTextLevel1: "4",
          headerText2: l(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.InsuranceAdditionalInfo.CardHolderLabel"
          ),
          headerTextLevel2: "4",
          children: /* @__PURE__ */ e(
            se.Item,
            {
              itemText1: i,
              itemText2: m,
              onEditButtonClick: () => {
                n(a.id.toString());
              },
              onDeleteButtonClick: () => {
                o(a.id.toString());
              }
            }
          )
        },
        a.id
      );
    })
  ] });
}, Ro = ({ fields: s, setError: n }) => {
  const { queryParams: o } = te(), { data: l, error: a } = je({ queryParams: o }), { snackbarProps: d, showSnackbar: i } = _e(), m = l == null ? void 0 : l.insuranceInfo, { t: g } = z(), t = !(m != null && m.length) || (m == null ? void 0 : m.length) < 3, [f, u] = L({
    addOpen: !1,
    deleteOpen: !1,
    editId: "",
    deleteId: "",
    frontImage: null,
    backImage: null
  }), c = () => {
    i(
      g("Mho.PageContent.Profile.GeneralInformation.ProfileSuccessfullyChanged"),
      "success",
      10
    );
  };
  return v(() => {
    a && n(a == null ? void 0 : a.message);
  }, [a, n]), /* @__PURE__ */ E("div", { children: [
    m && /* @__PURE__ */ e(
      Bo,
      {
        insuranceItems: m,
        onEdit: (p) => {
          u((F) => ({
            ...F,
            addOpen: !0,
            editId: p,
            frontImage: null,
            backImage: null
          }));
        },
        onDelete: (p) => {
          u((F) => ({
            ...F,
            deleteOpen: !0,
            deleteId: p
          }));
        }
      }
    ),
    t && /* @__PURE__ */ e(se, { headerText1: "", children: /* @__PURE__ */ e(
      se.AddButton,
      {
        text: g(
          "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.GeneralInsuranceInfo.AddInsuranceButtonLabel"
        ),
        onClick: () => {
          u((p) => ({
            ...p,
            addOpen: !0,
            editId: "",
            frontImage: null,
            backImage: null
          }));
        }
      }
    ) }),
    /* @__PURE__ */ e(
      ko,
      {
        isActive: f.addOpen,
        onClose: () => {
          u((p) => ({
            ...p,
            addOpen: !1,
            editId: "",
            frontImage: null,
            backImage: null
          }));
        },
        data: l,
        showSuccessSnackbar: c,
        insuranceId: f.editId,
        fields: s,
        setInsuranceImages: (p) => {
          p.front ? u((F) => ({
            ...F,
            frontImage: p.front ?? null
          })) : p.back && u((F) => ({
            ...F,
            backImage: p.back ?? null
          }));
        },
        frontImage: f.frontImage,
        backImage: f.backImage
      }
    ),
    /* @__PURE__ */ e(
      vo,
      {
        isOpen: f.deleteOpen,
        onClose: () => {
          u((p) => ({
            ...p,
            deleteOpen: !1,
            deleteId: ""
          }));
        },
        insuranceId: f.deleteId,
        showSuccessSnackbar: c
      }
    ),
    /* @__PURE__ */ e(qe, { ...d })
  ] });
}, Oo = ({
  imageId: s,
  setInsuranceNewCard: n,
  cardLabel: o,
  cardDescription: l,
  setIsLoading: a
}) => {
  const { t: d } = z(), [i, m] = L(null), [g, t] = L(s), [f, u] = L(!1), {
    data: c,
    isSuccess: r,
    isPending: I
  } = ze(g), p = s && I || f;
  return v(() => {
    if (r && c) {
      const F = new File([c], "cardFront", {
        type: c == null ? void 0 : c.type
      });
      m(F);
    }
  }, [r]), v(() => {
    i && n({
      file: i,
      imageType: "passport",
      id: g
    });
  }, [i]), v(() => {
    a(p);
  }, [p]), /* @__PURE__ */ e(V, { children: /* @__PURE__ */ e("div", { className: "d-flex flex-row gap-4 justify-content-center", children: /* @__PURE__ */ e("div", { className: "w-100 w-sm-50", children: /* @__PURE__ */ e(
    He,
    {
      image: i ?? null,
      setImage: (F) => {
        F && (Oe(
          F,
          Ve,
          m,
          u
        ), t(""));
      },
      cardTitle: o || d(
        "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddFrontCardLabel"
      ),
      cardDescription: l || d(
        "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.AddCardUploadLabel"
      ),
      maxFileSizeKB: 3584,
      supprortedFileTypes: [
        ae.jpeg,
        ae.jpg,
        ae.png
      ],
      fileSizeErrorText: d(
        "Mho.Profile.InsuranceEmploymentInformation.PhotoId.ErrorImageSize"
      ),
      fileTypeErrorText: d(
        "Mho.PageContent.Profile.GeneralInformation.ImageRestrictionsLabel"
      ),
      reUploadText: d(
        "Mho.Profile.InsuranceEmploymentInformation.PhotoId.ReUploadImageLabel"
      ),
      uploadedImageAltText: d(
        "Mho.Profile.InsuranceEmploymentInformation.PhotoId.UploadedPreviewLabel"
      )
    }
  ) }) }) });
}, Z = {
  passport: "passport",
  driversLicense: "driversLicense"
}, Q = {
  passport: "passport",
  licenseFront: "licenseFront",
  licenseBack: "licenseBack"
}, Ho = ({
  isOpen: s,
  userPhotoIds: n,
  user: o,
  onClose: l,
  showSuccessSnackbar: a,
  currentDocumentType: d
}) => {
  var he, oe, ye, ce, ge, b, x;
  const { t: i } = z(), [m, g] = L(
    ((he = n == null ? void 0 : n.find((M) => M.type === Q.licenseFront)) == null ? void 0 : he.imageId) || ""
  ), [t, f] = L(
    ((oe = n == null ? void 0 : n.find((M) => M.type === Q.licenseBack)) == null ? void 0 : oe.imageId) || ""
  ), [u, c] = L(
    ((ye = n == null ? void 0 : n.find((M) => M.type === Q.passport)) == null ? void 0 : ye.imageId) || ""
  ), [r, I] = L(
    d === "licenseFront" || d === "licenseBack" ? Z.driversLicense : d || ""
  ), [p, F] = L(m || ""), [k, G] = L(t || ""), [q, U] = L(u || ""), [h, X] = L(null), [$, K] = L(null), [j, B] = L(""), [J, fe] = L(!1), le = ((ce = h == null ? void 0 : h.front) == null ? void 0 : ce.file) || "", W = ((ge = h == null ? void 0 : h.back) == null ? void 0 : ge.file) || "", R = () => {
    X(null), K(null), B(""), l();
  }, { connectedRelUsername: P } = te();
  v(() => {
    var M, re, Fe;
    I(
      d === "licenseFront" || d === "licenseBack" ? Z.driversLicense : d || ""
    ), g(
      ((M = n == null ? void 0 : n.find((O) => O.type === Q.licenseFront)) == null ? void 0 : M.imageId) || ""
    ), f(
      ((re = n == null ? void 0 : n.find((O) => O.type === Q.licenseBack)) == null ? void 0 : re.imageId) || ""
    ), c(
      ((Fe = n == null ? void 0 : n.find((O) => O.type === Q.passport)) == null ? void 0 : Fe.imageId) || ""
    );
  }, [s, n, d]), v(() => {
    F(m), G(t), U(u);
  }, [m, t, u]);
  const { mutate: ie, isPending: me } = Ke({
    onMutate: () => {
      B("");
    },
    onSuccess: () => {
      R(), a();
    },
    onError: () => {
      B(i("Mho.FormValidations.FailedToSave"));
    }
  }), { mutate: D, isPending: ee } = kn({
    onMutate: () => {
      B("");
    },
    onSuccess: (M) => {
      M.status.code === 200 && (M.data.imageType === "insuranceFront" && F(M.data.imageId), M.data.imageType === "insuranceBack" && G(M.data.imageId), M.data.imageType === "passport" && U(M.data.imageId));
    },
    onError: (M) => {
      B((M == null ? void 0 : M.message) || i("Mho.FormValidations.FailedToSave"));
    }
  }), ne = r === Z.driversLicense ? A(h == null ? void 0 : h.front) || m !== "" && m === ((b = h == null ? void 0 : h.front) == null ? void 0 : b.id) || A(h == null ? void 0 : h.back) || t !== "" && t === ((x = h == null ? void 0 : h.back) == null ? void 0 : x.id) : A($) || u !== "" && u === ($ == null ? void 0 : $.id);
  v(() => {
    if (!ne) {
      const M = h != null && h.front ? Ne(h == null ? void 0 : h.front) : null;
      M && D(M);
    }
    if (!ne) {
      const M = h != null && h.back ? Ne(h == null ? void 0 : h.back) : null;
      M && D(M);
    }
  }, [le, W]), v(() => {
    if (!ne) {
      const M = $ ? Ne($) : null;
      M && D(M);
    }
  }, [$]);
  const be = () => {
    if (A(p) && A(k) && A(q))
      B(i("Mho.FormValidations.FailedToSave"));
    else {
      const M = r === Z.driversLicense ? !A($) && u !== "" : !A(h) && m !== "", re = r === Z.driversLicense ? [
        {
          type: Q.licenseFront,
          imageId: p
        },
        {
          type: Q.licenseBack,
          imageId: k
        }
      ] : [
        {
          type: Q.passport,
          imageId: q
        }
      ];
      M && r === Z.driversLicense ? re.push({
        type: Q.passport,
        imageId: q,
        delete: !0
      }) : M && r === Z.passport && re.push(
        {
          type: Q.licenseFront,
          imageId: p,
          delete: !0
        },
        {
          type: Q.licenseBack,
          imageId: k,
          delete: !0
        }
      ), ie({ user: o, photoIds: re, connectedRelUsername: P });
    }
  };
  return /* @__PURE__ */ e(
    _,
    {
      active: s,
      label: i("Mho.Profile.InsuranceEmploymentInformation.PhotoId.PanelUploadLabel"),
      size: "large",
      backdropDismiss: !1,
      onNeuDismiss: R,
      children: /* @__PURE__ */ E("div", { className: $e("pt-1 p-3", Ye.modalContentContainer), children: [
        me ? /* @__PURE__ */ e(Pe, { kind: "spinner", size: "small" }) : /* @__PURE__ */ E(V, { children: [
          /* @__PURE__ */ e(Ae, { kind: "error", showAlert: !!j, className: "mb-4", children: j }),
          /* @__PURE__ */ e("p", { children: i("Mho.Profile.InsuranceEmploymentInformation.PhotoId.PanelUploadText") }),
          /* @__PURE__ */ e("p", { className: "neu-display-6 fw-bold", children: i("Mho.Profile.InsuranceEmploymentInformation.PhotoId.SelectIdLabel") }),
          /* @__PURE__ */ E(
            Me,
            {
              label: "",
              value: r,
              onNeuChange: (M) => {
                I(M.value);
              },
              required: !0,
              children: [
                /* @__PURE__ */ e(
                  Me.Item,
                  {
                    label: i(
                      "Mho.Profile.InsuranceEmploymentInformation.PhotoId.SelectTypeLicenseLabel"
                    ),
                    value: Z.driversLicense,
                    disabled: r === Z.passport && ee
                  },
                  "documentType-driversLicense"
                ),
                /* @__PURE__ */ e(
                  Me.Item,
                  {
                    label: i(
                      "Mho.Profile.InsuranceEmploymentInformation.PhotoId.SelectTypePassportLabel"
                    ),
                    value: Z.passport,
                    disabled: r === Z.driversLicense && ee
                  },
                  "documentType-passport"
                )
              ]
            }
          ),
          A(r) ? null : /* @__PURE__ */ E(V, { children: [
            /* @__PURE__ */ e("p", { className: "neu-display-6 fw-bold mt-4", children: i("Mho.Profile.InsuranceEmploymentInformation.PhotoId.UploadPhotoLabel") }),
            r === Z.driversLicense ? /* @__PURE__ */ e(
              Tn,
              {
                frontImageId: p,
                backImageId: k,
                setInsuranceNewCard: X,
                frontLabel: i(
                  "Mho.Profile.InsuranceEmploymentInformation.PhotoId.AddFrontOfIdLabel"
                ),
                backLabel: i(
                  "Mho.Profile.InsuranceEmploymentInformation.PhotoId.AddBackOfIdLabel"
                ),
                setIsLoading: fe
              }
            ) : /* @__PURE__ */ e(
              Oo,
              {
                imageId: q,
                setInsuranceNewCard: K,
                cardLabel: i(
                  "Mho.Profile.InsuranceEmploymentInformation.PhotoId.AddFrontOfIdLabel"
                ),
                setIsLoading: fe
              }
            )
          ] }),
          (ee || J) && /* @__PURE__ */ E("div", { className: "d-flex justify-content-center flex-column align-items-center mt-4", children: [
            /* @__PURE__ */ e(Pe, { size: "small", kind: "spinner" }),
            /* @__PURE__ */ e("p", { children: i("Mho.Profile.InsuranceEmploymentInformation.PhotoId.LoadText") })
          ] })
        ] }),
        /* @__PURE__ */ E("div", { className: "d-flex flex-row gap-3 justify-content-end", children: [
          /* @__PURE__ */ e(xe, { kind: "secondary", type: "button", onNeuClick: R, children: i(
            "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.CancelButtonLabel"
          ) }),
          /* @__PURE__ */ e(
            xe,
            {
              type: "submit",
              color: "blue",
              kind: "primary",
              disabled: ne || ee || !!j,
              onNeuClick: be,
              children: i(
                "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.NewInsuranceForm.SaveButtonLabel"
              )
            }
          )
        ] })
      ] })
    }
  );
}, Vo = ({
  isOpen: s,
  onClose: n,
  showSuccessSnackbar: o,
  setError: l,
  account: a
}) => {
  const { t: d } = z(), { connectedRelUsername: i } = te(), { mutate: m, isPending: g } = Ke({
    onSuccess: () => {
      o(), n();
    },
    onError: () => {
      l(d("Mho.FormValidations.FailedToSave"));
    }
  }), t = () => {
    if (l(""), a && a.photoIds) {
      const f = a.photoIds.map((u) => ({ ...u, delete: !0 }));
      m({ user: a.user, photoIds: f, connectedRelUsername: i });
    }
  };
  return /* @__PURE__ */ e(
    _,
    {
      label: d("Mho.Profile.InsuranceEmploymentInformation.PhotoId.RemoveLabel"),
      size: "medium",
      active: s,
      onNeuDismiss: n,
      children: g ? /* @__PURE__ */ e(_.Content, { children: /* @__PURE__ */ e(Pe, { kind: "spinner", size: "small" }) }) : /* @__PURE__ */ E(V, { children: [
        /* @__PURE__ */ e(_.Content, { children: /* @__PURE__ */ e("p", { children: d("Mho.Profile.InsuranceEmploymentInformation.PhotoId.RemoveSublabel") }) }),
        /* @__PURE__ */ e(_.Footer, { children: /* @__PURE__ */ e(
          Ze,
          {
            buttonsAlignment: "end",
            primaryText: d(
              "Mho.Profile.InsuranceEmploymentInformation.ButtonLabels.YesButtonLabel"
            ),
            onPrimaryClick: t,
            secondaryText: d(
              "Mho.Profile.InsuranceEmploymentInformation.ButtonLabels.CancelButtonLabel"
            ),
            onSecondaryClick: n
          }
        ) })
      ] })
    }
  );
}, zo = ({ setError: s }) => {
  var p, F, k;
  const { t: n } = z(), {
    isOpen: o,
    openModal: l,
    closeModal: a
  } = ve(), {
    isOpen: d,
    openModal: i,
    closeModal: m
  } = ve(), { queryParams: g } = te({ levelOfDetail: "PHOTO" }), { data: t, error: f } = je({
    queryParams: g
  }), { snackbarProps: u, showSnackbar: c } = _e(), r = (k = (F = t == null ? void 0 : t.photoIds) == null ? void 0 : F[((p = t == null ? void 0 : t.photoIds) == null ? void 0 : p.length) - 1]) == null ? void 0 : k.type, I = () => {
    c(
      n("Mho.PageContent.Profile.GeneralInformation.ProfileSuccessfullyChanged"),
      "success",
      10
    );
  };
  return v(() => {
    f && s(f == null ? void 0 : f.message);
  }, [f]), A(t) ? null : /* @__PURE__ */ E(V, { children: [
    /* @__PURE__ */ e(Be, { level: "3", className: "fw-bold mt-4 neu-display-5", marginBottom: "0", children: n("Mho.Profile.InsuranceEmploymentInformation.PhotoId.SectionLabel") }),
    A(t == null ? void 0 : t.photoIds) ? /* @__PURE__ */ e(se, { headerText1: "", children: /* @__PURE__ */ e(
      Cn,
      {
        text: n("Mho.Profile.InsuranceEmploymentInformation.PhotoId.AddPhotoIdLabel"),
        onClick: () => l()
      }
    ) }) : /* @__PURE__ */ e(se, { headerText1: "", children: /* @__PURE__ */ e(
      xn,
      {
        itemText1: n(
          r === "passport" ? "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.GeneralInsuranceInfo.PhotoIdPlaceholder" : "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.InsuranceAdditionalInfo.DriverLicenseUpdatedText"
        ),
        onEditButtonClick: () => l(),
        onDeleteButtonClick: () => i()
      }
    ) }),
    /* @__PURE__ */ e(
      Ho,
      {
        isOpen: o,
        user: t == null ? void 0 : t.user,
        userPhotoIds: t == null ? void 0 : t.photoIds,
        onClose: a,
        showSuccessSnackbar: I,
        currentDocumentType: r
      }
    ),
    /* @__PURE__ */ e(
      Vo,
      {
        isOpen: d,
        onClose: m,
        showSuccessSnackbar: I,
        setError: s,
        account: t
      }
    ),
    /* @__PURE__ */ e(qe, { ...u })
  ] });
}, qo = ({
  rendering: s,
  fields: n
}) => {
  const { t: o } = z(), [l, a] = L("");
  return /* @__PURE__ */ e(Gn, { className: "p-3", children: /* @__PURE__ */ E(
    jn,
    {
      componentName: s == null ? void 0 : s.componentName,
      level: "2",
      titleClassName: "neu-display-3 fw-bold",
      titleText: o(
        "Mho.Profile.InsuranceEmploymentInformation.InsuranceInfo.GeneralInsuranceInfo.Title"
      ),
      descriptionRichText: n.insuranceDescription,
      errorMessage: l,
      errorDisplayDurationInSeconds: 10,
      children: [
        /* @__PURE__ */ e(Ro, { fields: n, setError: a }),
        /* @__PURE__ */ e(zo, { setError: a }),
        /* @__PURE__ */ e(ho, { fields: n, setError: a })
      ]
    }
  ) });
}, hr = _n()(
  qo
);
export {
  hr as MhoInsuranceAndPhotoId
};
